import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { Common, RequestBodyCommon } from '../models/commonConfig.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MaintainanceService {
  private lineServiceUrl: string = environment.endpointBackend + '/api/line';
  constructor(
    private http: HttpClient,
  ) { }

  // 1_2125
  apiGetMaintainance(): Observable<PayloadResponse<any>> {
    return this.http.post<ApiResponse<any>>(this.lineServiceUrl + '/maintainance',"").pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }
}
